import type { StyleData } from "@ui5/webcomponents-base/dist/types.js";

const styleData: StyleData = {packageName:"@udex/web-components",fileName:"themes/sap_horizon/parameters-bundle.css.ts",content:``};
export default styleData;
	